import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import CssBaseline from '@mui/material/CssBaseline';

// Theme
import theme from './styles/theme';

// Context Providers
import { AuthProvider } from './context/AuthContext';
import { AppProvider } from './context/AppContext';

// Components
import ErrorBoundary from './components/ErrorBoundary';

// Layout
import Layout from './components/layout/Layout';

// Pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import TeamPage from './pages/TeamPage';
import ContactPage from './pages/ContactPage';
import ServicesPage from './pages/ServicesPage';
import BookingPage from './pages/BookingPage';
import ModifyBookingPage from './components/booking/ModifyBookingPage';
import CancelBookingPage from './components/booking/CancelBookingPage';
import CareersPage from './pages/CareersPage';
// import LoginPage from './pages/LoginPage';
// import RegisterPage from './pages/RegisterPage';
// import ProfilePage from './pages/ProfilePage';
// import AppointmentsPage from './pages/AppointmentsPage';
import AdminDashboardPage from './pages/admin/DashboardPage';
import AdminLoginPage from './pages/AdminLoginPage';
import TermsPage from './pages/TermsPage';

// Auth
import ProtectedRoute from './components/auth/ProtectedRoute';

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <CssBaseline />
        <ErrorBoundary>
          <AuthProvider>
            <AppProvider>
              <Router>
                <Routes>
                  {/* Admin routes — no public Layout */}
                  <Route path="/admin" element={<AdminLoginPage />} />
                  <Route path="/admin/dashboard" element={
                    <ProtectedRoute requireAdmin>
                      <AdminDashboardPage />
                    </ProtectedRoute>
                  } />

                  {/* Public routes — wrapped in Layout */}
                  <Route path="/*" element={
                    <Layout>
                      <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/team" element={<TeamPage />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="/services" element={<ServicesPage />} />
                        <Route path="/booking" element={<BookingPage />} />
                        <Route path="/booking/modify/:appointmentId" element={<ModifyBookingPage />} />
                        <Route path="/booking/cancel/:appointmentId" element={<CancelBookingPage />} />
                        <Route path="/careers" element={<CareersPage />} />
                        <Route path="/terms" element={<TermsPage />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                      </Routes>
                    </Layout>
                  } />
                </Routes>
              </Router>
            </AppProvider>
          </AuthProvider>
        </ErrorBoundary>
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default App;
